import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend,
  } from 'recharts';
import { Card, CardContent } from "../../../components/ui/card";
import constants from '../../../commonUtils/constants';


const UploadsByProject = ({ data }) => {

    return (
        <>
            <Card className="shadow-md rounded-2xl">
                <CardContent>
                    <h2 className="text-lg font-bold mb-4">Uploads by Project</h2>
                    <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis allowDecimals={false}/>
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="uploads" fill={constants.dashboard.colors[6]} radius={[4, 4, 0, 0]} name="Project Upload Count" />
                        </BarChart>
                    </ResponsiveContainer>
                </CardContent>
            </Card>
        </>
    );
};

export default UploadsByProject;
